import React, { ChangeEventHandler } from "react";
import { monthNames } from "utils/translationDictionary";

interface IProps {
  name?: string;
  defaultValue?: number;
  onChange?: ChangeEventHandler<HTMLSelectElement>;
  register?: any;
  classes?: string;
  disabled?: boolean;
}

const MonthSelect = ({
  name = "month",
  register,
  defaultValue,
  onChange,
  classes,
  disabled
}: IProps) => {
  return (
    <select
      name={name}
      ref={register}
      defaultValue={defaultValue}
      onChange={onChange}
      className={classes}
      disabled={disabled}
    >
      {/* THIS MAKES PROBLEM ON RESOURCES MODULE */}
      {/* <select {...register(name)} defaultValue={defaultValue} onChange={onChange}> */}
      {monthNames.map((month, index) => (
        <option value={index + 1} key={index + 1}>
          {month}
        </option>
      ))}
    </select>
  );
};

export default MonthSelect;
